// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Production values (these are public values anyway)
const PROD_SUPABASE_URL = 'https://api.tivo.bio';
const PROD_SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Indkc255eXFycGJoZXh2dXhjenJzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzcyNjkxNTUsImV4cCI6MjA1Mjg0NTE1NX0.ietUEjxnmfD_ej4w2KWjAqXN3SshzFwZOl09ODPBPc4';

// Use environment variables in development, fallback to production values
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || PROD_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || PROD_SUPABASE_ANON_KEY;

// Create the Supabase client
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey);

// Create a separate client for global/public access
export const globalSupabase = createClient<Database>(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      persistSession: false, // Don't persist the anonymous session
      autoRefreshToken: false, // Don't try to refresh the token
      detectSessionInUrl: false // Don't look for the session in URL
    }
  }
);